const initialState = {
    'Electronic Sub':'0',
    'Paper Sub':'0',
    'Submission Batches':'0',
    'EDI Reports':'0',
    'Claim Tracker':'0',
    'Responses':'0',
}


const SubmissionCountReducer = ( state = initialState, action) => {
    switch(action.type){
        case 'ELECTRONIC_SUBMISSION' : return {...state, 'Electronic Sub': action.payload };
        case 'PAPER_SUBMISSION' : return {...state, 'Paper Sub': action.payload };
        case 'SUBMISSION_BATCHES' : return {...state, 'Submission Batches': action.payload };
        case 'EDI_REPORTS' : return {...state, 'EDI Reports': action.payload };
        case 'CLAIM_TRACKER' : return {...state, 'Claim Tracker': action.payload };
        case 'RESPONSES' : return {...state, 'Responses': action.payload };
        default: return state;
    }
}

export default SubmissionCountReducer
